<div class="pagination">
  <div class="pag-wrapper">
    <mat-form-field appearance="outline" class="page-no-field" [style.width.px]="75">
      <mat-label style="font-size: 15px;" appRemoveAriaOwns>Page No</mat-label>
      <mat-select panelClass="cbo-paginator-panel" [formControl]="pageNoCtrl" (selectionChange)="pageNoChange()"
        [disableOptionCentering]="true" #selectPaNo>
        @if (selectPaNo.focused) {
        <mat-option class="search-option" (keydown)="$event.stopPropagation()">
          <lib-mat-select-search [list]="pageNoArr"
            (filtered)="pageNoArrFilter = ($event || null).filter(x => typeof x === 'string')">
          </lib-mat-select-search> </mat-option>} @for (opt of pageNoArrFilter; track opt) { <mat-option [value]="opt">
          {{opt}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-paginator [length]="paginationLastNo*10" [pageSize]="10" [pageSizeOptions]="[10]" [pageIndex]="pageIndex"
      [hidePageSize]="true" [showFirstLastButtons]="true" aria-label="Select page" (page)="pageChange($event)">
    </mat-paginator>
  </div>
</div>